export default {
  holidays: null
};